
export enum MediaState {
  Valid = 'valid',
  Invalid = 'invalid',
  Uploading = 'uploading'
}
